import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { RootState } from './types';

// Use the notification module from Vue Dot
import { notification } from '@cnamts/vue-dot/src/modules/notification';
import { addressData } from '@/store/modules/address';

Vue.use(Vuex);

/** @see https://vuex.vuejs.org/fr/getting-started.html for help */
const storeOptions: StoreOptions<RootState> = {
	strict: true,
	state: {},
	/** @see https://vuex.vuejs.org/guide/modules.html for more informations on modules */
	modules: {
		notification,
		addressData
	}
};

export const store = new Vuex.Store<RootState>(storeOptions);
